module.exports = __webpack_public_path__ + "img/201.ec0be67f.png";